import React from "react";
import { Card } from "../../common/components/elements/Card";
import LoadingWrapper from "../../common/components/elements/LoadingWrapper";
import { useQuery } from "@apollo/client";
import userIdentity from "../../trackdechets/qraphql/queries/userIdentity.graphql";
import { useAuth } from "../contexts/useAuth";
import TrackdechetsStatus from "../../trackdechets/components/TrackdechetsStatus";
import { ROUTE_TRACKDECHETS_OAUTH_CALLBACK } from "../../../routes";
import ContentPage from "../../common/components/layout/ContentPage";
import StatelessCheckbox from "../../common/components/form/StatelessCheckbox";
import I18n from "i18n-js";
import { subscribeToTrackdechetsNotifications, unsubscribeFromTrackdechetsNotifications } from "../actions/authActions";
import { useDispatch } from "react-redux";

export default function AccountPage() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { loading, error, data } = useQuery(userIdentity, {
    variables: {
      userUuid: user.uuid,
    },
  });

  const callbackUri = new URL(
    ROUTE_TRACKDECHETS_OAUTH_CALLBACK,
    window.location.origin,
  );
  const trackdechetsUri = `${AppConfig.URL_TRACKDECHETS_AUTH}?response_type=code&redirect_uri=${callbackUri}&client_id=${AppConfig.CLIENT_ID_TRACKDECHETS_AUTH}`;

  const toggleSubscription = () => {
    if (user.subscribedToFIBSDNotifications) {
      dispatch(unsubscribeFromTrackdechetsNotifications());
    } else {
      dispatch(subscribeToTrackdechetsNotifications());
    }
  };

  return (
    <ContentPage title={I18n.t('pages.account.title')}>
      <Card>
        <div className="pb-3">
          <h4>{I18n.t('pages.account.trackdechets.title')}</h4>
          <LoadingWrapper loading={loading} error={Boolean(error)}>
            {() => {
              if (data.userIdentity) {
                return <TrackdechetsStatus userIdentity={data.userIdentity} />;
              }

              return (
                <div className="row justify-content-center m-3">
                  <a className={"btn btn-primary"} href={trackdechetsUri}>
                    {I18n.t('pages.account.trackdechets.link')}
                  </a>
                </div>
              );
            }}
          </LoadingWrapper>
        </div>
        <div>
          <h4>{I18n.t('pages.account.notifications.title')}</h4>
          <div className="mt-3">
            <StatelessCheckbox
              key="subscribeToTrackdechetNotifications"
              id="subscribeToTrackdechetNotifications"
              label={I18n.t("pages.account.notifications.subscribeToFIBSD")}
              checked={user.subscribedToFIBSDNotifications ?? false}
              onChangedValue={toggleSubscription}
            />
          </div>
        </div>
      </Card>
    </ContentPage>
  );
}
